// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1_8Le","label":"Labeled_label__1Mj_Z","divider":"Labeled_divider__iQVyb"};